import React from "react";

type CategoryTournamentTitleProps = {
    categoryName: string;
    tournamentName: string;
    categoryImageUrl?: string
}

export const CategoryTournamentTitle = React.memo((props: CategoryTournamentTitleProps) => {
    const {categoryName, tournamentName, categoryImageUrl} = props;
    return (
        <div className="flex items-center p-[10px] tablet:text-[16px]  tablet:py-[5px] tablet:pl-[14px]">
            {categoryImageUrl ? <img className="w-[28px] h-[20px]" src={categoryImageUrl} alt="flag"/> : 'no_img'}
            <div className="text-[#ABABAB] px-[8px] max-tablet:text-[10px] max-tablet:font-normal max-tablet:tracking-[0.4px] tablet:px-[19px] tablet:text-[#D7D8D9]">{categoryName}. {tournamentName}</div>
        </div>
    )

}, (prevProps, nextProps) => {
    return prevProps.categoryName === nextProps.categoryName &&
        prevProps.tournamentName === nextProps.tournamentName &&
        prevProps.categoryImageUrl === nextProps.categoryImageUrl
})
